import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=b2cc172c&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=b2cc172c&prod&lang=scss&scoped=true"
import style1 from "./delivery.vue?vue&type=style&index=1&id=b2cc172c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cc172c",
  null
  
)

export default component.exports